import { atomWithReset as stateSegmentWithReset } from 'jotai/utils';
import { GenerateContentValidationStateType } from '../../../types/contentValidation';
import { QcReviewName } from '../../../types/QualityChecks';

export const GenerateContentValidationStateSegment =
  stateSegmentWithReset<GenerateContentValidationStateType>({});

GenerateContentValidationStateSegment.debugLabel =
  'GenerateContentValidationStateSegment';

// Utility function to check if any item has "NEEDS_REVIEW" status
export const hasNeedsReview = (
  data: GenerateContentValidationStateType
): boolean => {
  return Object.values(data).some(
    item => item.status === QcReviewName.NEEDS_REVIEW
  );
};
